module.exports = __webpack_public_path__ + "static/media/banner_white@140x140.7d19b33c.png";